/*! js-cookie v3.0.1 | MIT */
;(function(global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? (module.exports = factory())
    : typeof define === 'function' && define.amd
    ? define(factory)
    : ((global = global || self),
      (function() {
        var current = global.Cookies
        var exports = (global.Cookies = factory())
        exports.noConflict = function() {
          global.Cookies = current
          return exports
        }
      })())
})(this, function() {
  'use strict'

  /* eslint-disable no-var */
  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        target[key] = source[key]
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function(value) {
      if (value[0] === '"') {
        value = value.slice(1, -1)
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function(value) {
      return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent)
    },
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init(converter, defaultAttributes) {
    function set(key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes)

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5)
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString()
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape)

      var stringifiedAttributes = ''
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0]
      }

      return (document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes)
    }

    function get(key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : []
      var jar = {}
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=')
        var value = parts.slice(1).join('=')

        try {
          var foundKey = decodeURIComponent(parts[0])
          jar[foundKey] = converter.read(value, foundKey)

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function(key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1,
            })
          )
        },
        withAttributes: function(attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function(converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        },
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) },
      }
    )
  }

  var api = init(defaultConverter, { path: '/' })
  /* eslint-enable no-var */

  return api
})

/* cookie utils */
function readAndCleanPageData(dataID) {
  if (!dataID) {
    return false
  }
  try {
    // Always return textContent over something like innerHTML to prevent XSS attacks
    return JSON.parse(document.getElementById(dataID).textContent, (key, value) => {
      // deletes falsey values from the JSON array
      if (!value) {
        return undefined
      }
      return value
    })[0]
  } catch (e) {
    return console.error(e)
  }
}

function getPageData(...dataTypes) {
  const data = readAndCleanPageData('cc-segment-data')
  if (!data) {
    return false
  }
  const filteredData = {}
  for (const [key] of Object.entries(data)) {
    if (dataTypes.includes(key.toString())) {
      filteredData[key] = data[key]
    }
  }
  return filteredData
}

function getAttrValue(node, dataAttr) {
  return node.getAttribute(dataAttr)
}

const dataTypes = {
  request: 'request',
  customer: 'customer',
  product: 'product',
  collection: 'collection',
  page: 'page',
  cart: 'cart',
}

function track(value, dataType = null, event = {}) {
  if (value === '') {
    return false
  }

  const properties = {
    ...(dataType && getPageData(dataType)[dataType]),
    ...(event.target && { eventValue: event.target.value }),
  }

  if (!window.analytics) {
    return false
  }

  window.analytics.track(value, properties)
  return true
}

function getVariantData() {
  const url = new URL(window.location.href)
  const variant = window.ShopifyAnalytics.meta.product.variants.find((v) => String(v.id) === url.searchParams.get('variant'))
  return variant ? { variantID: String(variant.id), variantName: variant.name } : {}
}

function trackAddProduct(dataAttr, eventType) {
  const nodes = document.querySelectorAll(`[${dataAttr}]`)

  nodes.forEach((node) => {
    let value = getAttrValue(node, dataAttr)

    node.addEventListener(eventType, () => {
      window.analytics.track(value, { ...getVariantData(), ...getPageData(dataTypes.product)[dataTypes.product] })
    })
  })
  return true
}

function trackEvent(dataAttr, eventType, dataType) {
  const nodes = document.querySelectorAll(`[${dataAttr}]`)

  nodes.forEach((node) => {
    let value = getAttrValue(node, dataAttr)

    if (value !== '') {
      node.addEventListener(eventType, (event) => {
        track(value, dataType, event)
      })
    }
  })
  return true
}

function reattachTrackerOnMutation(selector, trackers) {
  const collectionResultContainer = document.querySelector(selector)

  if (!collectionResultContainer) {
    return false
  }
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target === collectionResultContainer) {
        trackers.forEach((tracker) => {
          tracker()
        })
      }
    })
  })

  observer.observe(collectionResultContainer, {
    attributes: false,
    childList: true,
    characterData: false,
  })
  return true
}

function startIntersectionObserver(dataAttr) {
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      let value = getAttrValue(entry.target, dataAttr)

      if (value !== '' && entry.isIntersecting) {
        track(`Scrolled into view: ${value}`)
      }
    })
  }

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    rootMargin: '0px',
    threshold: 0.25,
  })

  const nodes = document.querySelectorAll(`[${dataAttr}]`)
  nodes.forEach((node) => {
    observer.observe(node)
  })
}

function trackPagination(event) {
  const url = new URL(event.currentTarget.responseURL)
  track(`Loaded page ${url.searchParams.get('page')}`, dataTypes.collection)
}

function trackSearch(dataAttr, inputAttr) {
  const node = document.querySelectorAll(`[${dataAttr}]`)[0]

  if (!node) {
    return false
  }
  let lastSearchTerm = null
  let lastTrackedTerm = null

  new MutationObserver(() => {
    const input = document.querySelector(`[${inputAttr}]`)

    if (lastSearchTerm === input.value && lastTrackedTerm !== input.value) {
      const value = getAttrValue(node, dataAttr)
      track(`${value} ${lastSearchTerm}`)
      lastTrackedTerm = input.value
    }
    lastSearchTerm = input.value
  }).observe(node, {
    subtree: true,
    childList: true,
  })
  return true
}

function loadSegmentSnippet() {
  var analytics = (window.analytics = window.analytics || [])
  if (!analytics.initialize)
    if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.')
    else {
      analytics.invoked = !0
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware',
      ]
      analytics.factory = function(e) {
        return function() {
          var t = Array.prototype.slice.call(arguments)
          t.unshift(e)
          analytics.push(t)
          return analytics
        }
      }
      for (var e = 0; e < analytics.methods.length; e++) {
        var key = analytics.methods[e]
        analytics[key] = analytics.factory(key)
      }
      analytics.load = function(key, e) {
        var t = document.createElement('script')
        t.type = 'text/javascript'
        t.async = !0
        t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
        var n = document.getElementsByTagName('script')[0]
        n.parentNode.insertBefore(t, n)
        analytics._loadOptions = e
      }
      analytics._writeKey = 'tU7cBGyssfIC8PSSoJly60YLgNLjkxSs'
      analytics.SNIPPET_VERSION = '4.13.2'
      analytics.load('tU7cBGyssfIC8PSSoJly60YLgNLjkxSs')
      analytics.page()
    }
}

function identifyOnLoad() {
  const customer = getPageData(dataTypes.customer)[dataTypes.customer]

  if (!window.analytics || !customer) {
    return false
  }

  window.analytics.identify(customer.id, {
    name: customer.name,
    email: customer.email,
  })
  return true
}

function registerAllCoreTracking() {
  trackAddProduct('data-track-atc', 'click')
  trackEvent('data-track-variant', 'click', dataTypes.product)
  trackEvent('data-track-item', 'click', dataTypes.request)
  trackEvent('data-track-button', 'click', dataTypes.request)
  trackEvent('data-track-sort-coll', 'change', dataTypes.collection)
  trackEvent('data-track-show-n-items', 'click', dataTypes.collection)
  trackEvent('data-track-filter', 'click', dataTypes.collection)

  const trackSearchItemClick = () => trackEvent('data-track-search-item', 'click', dataTypes.request)
  trackSearchItemClick()
  reattachTrackerOnMutation('#data-track-search-result-header', [trackSearchItemClick])
  reattachTrackerOnMutation('#data-track-search-result-header-top-center', [trackSearchItemClick])
  reattachTrackerOnMutation('#data-track-search-result-main', [trackSearchItemClick])
  const trackHotspotClick = () => trackEvent('data-track-hotspot', 'click', dataTypes.request)
  trackHotspotClick()
  reattachTrackerOnMutation('[data-shoppable-image-container]', [trackHotspotClick])
  const trackQuantityChanges = () => trackEvent('data-track-quantity', 'click', dataTypes.request)
  const trackRemoveFromCart = () => trackEvent('data-track-rfc', 'click', dataTypes.request)
  trackQuantityChanges()
  reattachTrackerOnMutation('[data-track-item-controls]', [trackRemoveFromCart, trackQuantityChanges])

  trackSearch('data-track-search-header', 'data-search-input-header')
  trackSearch('data-track-search-top-center', 'data-search-input-top-center')
  trackSearch('data-track-search-main', 'data-search-input-main')
  startIntersectionObserver('data-track-scroll')

  return true
}

async function initTheLoftAnalytics() {
  await Promise.all([loadSegmentSnippet(), identifyOnLoad(), registerAllCoreTracking()])
    // eslint-disable-next-line no-console
    .catch((error) => console.error(error))
}

function getBannerEl() {
  return document.getElementsByClassName('js-cc-cookie-consent')[0]
}

function hideBanner() {
  getBannerEl().style.display = 'none'
}

function showBanner() {
  getBannerEl().style.display = 'block'
}

function handleAccept() {
  window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner)
  initTheLoftAnalytics().then(() => Cookies.set('etl-analytics-accepted', 'true'))
  initGTM();
}

function handleDecline() {
  window.Shopify.customerPrivacy.setTrackingConsent(false, hideBanner)
  Cookies.set('etl-analytics-accepted', 'false')
}

function registerCookieConsentListeners() {
  const cookieAcceptButton = document.getElementsByClassName('js-cc-cookie-accept')[0]

  const cookieRejectButton = document.getElementsByClassName('js-cc-cookie-decline')[0]

  const cookieLearnMoreButton = document.querySelector('.js-cc-cookie-more')
  const cookieLearnMoreText = document.querySelector('.js-cookie-use-text')

  cookieLearnMoreButton.addEventListener('click', () => {
    cookieLearnMoreText.style.display = 'block'
    cookieLearnMoreButton.style.display = 'none'
    cookieRejectButton.style.display = 'inline-flex'
  })

  cookieAcceptButton.addEventListener('click', handleAccept)
  cookieRejectButton.addEventListener('click', handleDecline)
}

function initCookieBanner() {
  registerCookieConsentListeners()

  const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked()
  const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent()
  const userCanBeTrackedByShopify = !userCanBeTracked && userTrackingConsent === 'no_interaction'
  const etlTrackingCookie = Cookies.get('etl-analytics-accepted')
  const userCanBeTrackedByTheLoft = !etlTrackingCookie || etlTrackingCookie !== 'false'

  if (userCanBeTrackedByShopify && userCanBeTrackedByTheLoft) {
    showBanner()
  }

  if (etlTrackingCookie === 'true') {
    initTheLoftAnalytics().then(() => console.log('Analytics loaded'))
    initGTM();
  }
}

// Function initGTM added by Guus, guus@omelettedufromage.nl, fired after cookie consent is given. 
function initGTM() {
    // GTM
    const GTM_id = "GTM-P678D8J";
    if (GTM_id) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', GTM_id);
        (function appendGTMiFrame() {
            const noscript = document.createElement("noscript"), iframe = document.createElement("iframe");
            iframe.src = "https://www.googletagmanager.com/ns.html?id=" + GTM_id;
            iframe.style = "display: none; visibility: hidden;";
            iframe.height = 0; iframe.width = 0;
            noscript.append(iframe);

            window.addEventListener("load", () => { document.body.prepend(iframe); });
        })();
    }

  // Custom tracking event for Klavio popup, as I could not specifically target this click through standard GTM variables. 
  window.addEventListener("click", (e) => {
    if(e.target.tagName != "BUTTON" || !e.target.closest("form.needsclick.klaviyo-form")) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "odf_popup_signup"
    });
  });
}


async function initAnalyticsConsent() {
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],

    (error) => {
      if (error) {
        throw error
      }

      initCookieBanner()
    }
  )
}

;(async () => {
  await initAnalyticsConsent()
})()
